
import { useRoute, useRouter } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import { Field, Form } from "vee-validate";
import { checkSidAllNotReqd } from "@/commons/inputCheckCommon";
import * as Yup from "yup";
import { UserBaseMailPermission } from "@/commons/interfaces";
import { MailPermissionItem } from "@/modules/mailPermission";

export default defineComponent({
    name: "MailPermission",
    components: {
        Form,
        Field
    },
    setup() {
        const router = useRouter();
        const route = useRoute();

        const mailPermissionItem = MailPermissionItem.inject();
        const userMailPermission = mailPermissionItem.mailPermission as UserBaseMailPermission;
        const errorMsgRef = ref("");
        const formRef = ref<any>();

        const schema = Yup.object().shape({
            sidAll: checkSidAllNotReqd,
        });

        /**
         * 更新ボタン押下時処理
         */
        const update = () => {
            router.push({ name: "MailPermissionConfirm" });
        };

        onMounted((): void => {
            if (route.query.errorMsg) {
                errorMsgRef.value = route.query.errorMsg as string;
            }
        });

        return {
            userMailPermission,
            errorMsgRef,
            schema,
            formRef,
            update,
            router
        };
    },
});
